// @ts-nocheck
import PropTypes from 'prop-types';
import { Grid, Typography, Box, Link } from '@mui/material';
import React, { useCallback } from 'react';
import ImgNoProject from '../../assets/images/NoProjectImage.svg';

/**
 * @function NoProject
 * @description No Project component to display when there is no project
 * @returns {JSX} ProjectsOverview component
 * @example <NoProject history={history} />
 */
const NoProject = ({ user }) => {
  const showProjectsEvent = new Event('showProjects', { bubbles: true });
  const handleClick = useCallback(() => {
    document.dispatchEvent(showProjectsEvent);
  }, [showProjectsEvent]);
  return (
    <Box>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        height="calc(100vh - 64px)"
      >
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            role="img"
          >
            <img
              src={ImgNoProject}
              width="186.05"
              height={253.99}
              alt="NoProjectImage"
            />
          </Grid>
          <Grid item>
            <Typography
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              variant="h6"
              color="primary.main"
              align="center"
              tabIndex={0}
              sx={(theme) => ({
                '&:focus-visible': {
                  outline: 'none',
                  border: `2px solid ${theme?.palette?.primary?.main} !important`,
                },
              })}
            >
              Hi,
              {user?.userData?.username &&
                `${
                  user.userData.username.length > 15
                    ? ` ${user.userData.username.slice(0, 15)}...`
                    : ` ${user.userData.username}`
                }`}
              , please
              <Link
                onClick={handleClick}
                href="#button"
                style={{ cursor: 'pointer' }}
                underline="hover"
              >
                {' '}
                activate a project{' '}
              </Link>
              or create a new one.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
NoProject.propTypes = {
  user: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
export default NoProject;
